import React, { useState, useEffect, useCallback, useContext } from "react";

//libraries
import { Button, Input, Radio, Tabs, Modal, Form, message } from "antd";
import { BsRobot } from "react-icons/bs";
import { FaHashtag } from "react-icons/fa6";

//Hooks
import useAssistantFileUpload from "../../../Hooks/useAssistantFileUpload";

//Components
import AssistantForm from "./AssistantForm";
import { getCompId, getUserID, getUserRole } from "../../../Utility/service";
import { AssistantContext } from "../../../contexts/AssistantContext";
import FunctionCallingAssistantForm from "./FunctionCallingAssistantForm";
import { FileContext } from "../../../contexts/FileContext";
import axios from "axios";
import "../Assistant.css"
import { SLACK_MESSAGE_HISTORY_URL } from "../../../constants/Api_constants";
import { getUserData, getUserTeams } from "../../../api/userApiFunctions";

const { TabPane } = Tabs;

const CreateAssistantModal = ({ data }) => {
  const {
    assistantData,
    setAssistantData,
    assistantFunctionCallData,
    setAssistantFunctionCallData,
    showModal,
    handleClose,
    editMode,
    isAdmin,
    handleFetchUserCreatedAssistants,
    handleFetchAllAssistants,
    handleFetchFunctionCallingAssistants,
    isFunctionCallingAssistant,
    activeKey,
    setActiveKey,
    formattedRAGdData,
    formattedPublicFilesData,
    isModalClosed,
  } = data;



  const [form] = Form.useForm();
  const [deleteFileIds, setDeleteFileIds] = useState([]);
  const [selectedTools, setSelectedTools] = useState([]);
  const [selectedPlugins, setSelectedPlugins] = useState([]);

  const [knowledgeSource, setKnowledgeSource] = useState(false);
  const [activeKeyOfKnowledgeBase, setActiveKeyOfKnowledgeBase] = useState('1');
  const [connectApps, setConnectApps] = useState([]);
  const [isWorkBoardConnected, setIsWorkBoardConnected] = useState(false);
  const [isGoogleDriveConnected, setIsGoogleDriveConnected] = useState(false);
  const [isImportWebPagesConnected, setIsImportWebPagesConnected] = useState(false);
  const [enableSync, setEnableSync] = useState(false);
  const [isHubspotConnected, setIsHubspotConnected] = useState(false);
  const [isActiveCollabConnected, setIsActiveCollabConnected] = useState(false);
  const [channels, setChannels] = useState([]);
  const oauthToken = localStorage.getItem('oauthToken')
  const [isLoading, setIsLoading] = useState("")
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [functionCount, setFunctionCount] = useState(0);

  const { triggerRefetchAssistants } = useContext(AssistantContext);
  const { selectedFile, setSelectedFile, selectedFolders, setSelectedFolders, deletedFileList, setDeletedFileList } = useContext(FileContext);

  const userRole = getUserRole();
  const [image, setImage] = useState(null);

  //----Callback----//
  const handleDeleteFileId = useCallback(
    (index) => {
      const fileId = assistantData?.file_ids[index];
      setDeleteFileIds((prev) => [...prev, fileId]);
    },
    [assistantData.file_ids, setDeleteFileIds]
  );

  const getInitialFiles = useCallback(() => assistantData?.fileNames || [], [assistantData?.fileNames]);

  // SLACK

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedChannelId, setSelectedChannelId] = useState(null);
  const [selectedChannelName, setSelectedChannelName] = useState("");
  const [isSlackConnected, setIsSlackConnected] = useState(false);
  const [imageType, setImageType] = useState("DEFAULT");
  const [dalleImageDescription, setDalleImageDescription] = useState("");



  const handleSelectChannel = async () => {

    const oauthToken = localStorage.getItem("oauthToken");

    setIsLoading(true);
    try {
      const selectedChannel = filteredChannels.find(
        (channel) => channel.id === selectedChannelId
      );

      if (selectedChannel) {

        setSelectedChannelName(selectedChannel.name);

        const endpoint = `${SLACK_MESSAGE_HISTORY_URL}?oauthToken=${oauthToken}&channelId=${selectedChannelId}&limit=100`;
        const response = await fetch(endpoint);
        const textResponse = await response.text();

        try {
          const data = JSON.parse(textResponse);
          if (response.ok) {
          } else {
            console.error("Error fetching channel history:", data.error);
          }
        } catch (error) {
          console.error("Error parsing response as JSON:", error);
        }
      } else {
        console.error("No channel found with the provided ID:", selectedChannelId);
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    } finally {
      setIsModalOpen(false);
      setIsLoading(false);
    }
  };


  //------Hooks Declaration ------//
  const {
    fileList,
    setFileList,
    isUploading,
    handleCreateOrUpdateAssistantWithFiles,
    handleRemoveFile,
    handleAddFile,
    setCountTotalFile,
    countTotalFile,
    totalFileList,
    setTotalFileList
  } = useAssistantFileUpload(
    handleDeleteFileId,
    selectedTools,
    getInitialFiles
  );
  //--Side Effects---//
  useEffect(() => {
    if (isModalClosed || !showModal) {
      try {
        setFileList([]);
        setCountTotalFile(0);
        setSelectedFile([]);
        setSelectedFolders([]);
        setKnowledgeSource(false);
        form.resetFields();
        setActiveKeyOfKnowledgeBase('1');
        setTotalFileList([]);
        setIsGoogleDriveConnected(false);
        setIsWorkBoardConnected(false);
        setIsImportWebPagesConnected(false);
        setIsActiveCollabConnected(false);
        setConnectApps([]);
        setEnableSync(false);
        setIsHubspotConnected(false);
        setIsSlackConnected(false);
        setImage(null);
        setImageType("DEFAULT");
      } catch (error) {
        console.error("Error resetting modal data:", error);
      }
    }
  }, [isModalClosed, showModal]);


  useEffect(() => {
    form.setFieldsValue(assistantData);
    const newSelectedTools = assistantData?.tools?.map((tool) => tool) || [];
    setSelectedTools(newSelectedTools);
    if (editMode && fileList.length === 0) {
      setFileList((assistantData.fileIdsWithName || []).map(file => ({
        uid: file.file_id,
        name: file.filename,
        status: 'done',  // Assume files are already uploaded
        url: null,   // URL to the uploaded file
      })));
    }
    form.setFieldsValue({ knowledgeSource: knowledgeSource });

    if (editMode && assistantData?.dalleImageDescription) {
      setDalleImageDescription(assistantData.dalleImageDescription); 
    }


    if (editMode && assistantData?.knowledgeBaseInfo?.length > 0) {
      setSelectedFile(() => [...assistantData?.knowledgeBaseInfo]);
    }
    if (editMode && assistantData?.connectApps) {
      setConnectApps(assistantData?.connectApps);
      setIsGoogleDriveConnected(assistantData?.googleDrive);
      setIsWorkBoardConnected(assistantData?.workBoard);

      if (assistantData?.hubspotPipelines?.length > 0) {
        setIsHubspotConnected(assistantData?.hubspotPipelines);
      }
      setIsSlackConnected(assistantData?.slack);
    }
    if (editMode && assistantData?.enableSync) {
      setEnableSync(assistantData?.enableSync);

    }
    if (editMode && assistantData?.isActiveCollabEnabled) {
      setIsActiveCollabConnected(assistantData?.isActiveCollabEnabled);
      form.setFieldsValue({ activeCollab: assistantData?.isActiveCollabEnabled });
    }
    //cleanup
    return () => {
      setDeleteFileIds([]);
    }


  }, [assistantData, form]);



  //------Api calls --------//
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };
  const handleUploadFileAndCreateAssistant = async () => {
    try {
      const formData = new FormData();
      const formValues = form.getFieldsValue();
      formData.append("imageType", imageType);
      formData.append("dalleImageDescription", dalleImageDescription);
      formValues.connectApps = JSON.stringify(formValues.connectApps);
      formValues.fileNameList = JSON.stringify(selectedFile);

      
      // formValues.enableSync = formValues?.enableSync
      if (editMode) {
        formValues.deletedFileList = JSON.stringify(deletedFileList);
        setDeleteFileIds([]);
        setDeletedFileList([]);
      }

      if (!formValues.assistantId && !editMode) {
        await form.validateFields();
      }

      if (formValues.activeCollab === undefined) {
        formValues.activeCollab = false;
      }

      if (image) {
        formData.append('avatar', image);
      }
      fileList.forEach((file) => {
        formData.append("files", file);
      });

      if (selectedChannelId) {
        formData.append("channelId", selectedChannelId);
      }

      if (oauthToken != "") {
        formData.append("slackToken", oauthToken)
      }

      if (userRole === "superadmin") {
        formData.append("isAdminAgent", true);
      }

      if (formValues.team) {
        formValues.team.forEach((teamId) => {
          formData.append("teamId[]", teamId);
        });
      }


      if (deleteFileIds.length > 0) {
        formData.append("deleted_files", JSON.stringify(deleteFileIds));
      }
      formData.append("userId", getUserID());
      if (!editMode) {
        formData.append("orgId", getCompId());
      }
      if (!isAdmin) {
        formData.append("category", "PERSONAL");
      }
      const pipelines = formValues.hubspotPipelines;
      if (Array.isArray(pipelines)) {
        pipelines.forEach((pipeline, index) => {
          formData.append(`hubspotPipelines[]`, pipeline);
        })
      };

      Object.entries(formValues).forEach(([key, value]) => {
        if (key === "tools") {
          formData.append("tools", JSON.stringify(value));
        } else if (key === "plugins") {
          formData.append("plugins", JSON.stringify(value));
        }
        else if (key === "static_questions") {
          formData.append("staticQuestions", JSON.stringify(value));
        } else if (key === "photoOption") {
          if (editMode) {
            formData.append("regenerateWithDalle", value === "DALLE" ? "true" : "false");
          } else {
            formData.append("generateDalleImage", value === "DALLE" ? "true" : "false");
          }
        } else if (key === "functions") {
          let jsonArray = value.map(item => JSON.parse(item)); // Convert each item in the array from string to JSON
          let jsonString = JSON.stringify(jsonArray);
          formData.append("functionsArray", jsonString);
        }
        else {
          formData.append(key, value);
        }

      });

      const success = await handleCreateOrUpdateAssistantWithFiles(
        formData,
        editMode,
        assistantData?.assistant_id
      );

      if (success) {

        handleClose();
        handleFetchUserCreatedAssistants();
        if (editMode) {
          // update assistant list
          triggerRefetchAssistants();
        }
        if (isAdmin) {
          handleFetchAllAssistants(1);
        }
        setFileList([]);
        setCountTotalFile(0);
        setSelectedFile([]);
        setSelectedFolders([]);
        setKnowledgeSource(false);
        setTotalFileList([]);
        setActiveKeyOfKnowledgeBase('1');
        setIsGoogleDriveConnected(false);
        setIsWorkBoardConnected(false);
        setIsImportWebPagesConnected(false);
        setIsActiveCollabConnected(false);
        setConnectApps([]);
        setEnableSync(false);
        setIsHubspotConnected(false);
        setIsSlackConnected(false);
        setImage(null);

        form.resetFields();
      }
    } catch (error) {
      message.error("Please correct the errors in the form before proceeding.");
    }
  };

  //----Local Functions--------//
  const handleFormChange = (changedValues, allValues) => {
    setAssistantData((prevData) => ({
      ...prevData,
      ...changedValues,
    }));
  };

  const handleFunctionCallingFormChange = (changedValues, allValues) => {
    setAssistantFunctionCallData((prevData) => ({
      ...prevData,
      ...changedValues,
    }));
  };

  const filteredChannels = channels.filter(channel =>
    channel.name.toLowerCase().includes(search.toLowerCase())
  );


  const handleSwitchChangeOfKnowledgeBase = (tool, checked, functionCount = 0) => {
    const tools = form.getFieldValue("tools") || [];

    const updatedTools = checked
      ? [...tools, tool]
      : tools.filter((existingTool) => existingTool !== tool);
    form.setFieldsValue({ tools: updatedTools });
    setSelectedTools([updatedTools])

    setAssistantData((prevData) => ({
      ...prevData,
      tools: updatedTools
    }));
  };
  const handleSwitchChange = (tool, checked) => {
    const tools = form.getFieldValue("tools") || [];

    const updatedTools = checked
      ? [...tools, tool]
      : tools.filter((existingTool) => existingTool !== tool);
    form.setFieldsValue({ tools: updatedTools });
    setSelectedTools([updatedTools])

    setAssistantData((prevData) => ({
      ...prevData,
      tools: updatedTools
    }));
  };

  const handleSwitchChangeOfPlugin = (plugin, checked) => {
    const plugins = form.getFieldValue("plugins") || [];

    const updatedPlugins = checked
      ? [...plugins, plugin]
      : plugins.filter((existingPlugins) => existingPlugins !== plugin);
    form.setFieldsValue({ plugins: updatedPlugins });
    setSelectedPlugins([updatedPlugins])

    setAssistantData((prevData) => ({
      ...prevData,
      plugins: updatedPlugins
    }));
  };




  function handleTabChange(key) {
    setActiveKey(key);
  }

  return (
    <>
      <Modal
        title={editMode ? "" : "Create Agent"}
        open={showModal}
        onCancel={handleClose}
        afterClose={() => setActiveKey("unoptimized-data")}
        okButtonProps={{
          disabled: true,
        }}
        cancelButtonProps={{
          disabled: true,
        }}
        width={700}
        footer={null}
      >
        <Tabs
          defaultActiveKey="unoptimized-data"
          activeKey={activeKey}
          onChange={handleTabChange}
          className="mb-3 custom-tab"
          tabBarStyle={{ justifyContent: "space-around" }}
          centered
        >
          {<TabPane
            key="unoptimized-data"
            tab={
              <div
                style={{
                  display: "flex",
                  gap: ".6rem",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {editMode ? "" : <BsRobot />}
                <span>{editMode ? "Update Agent" : "New Agent"}</span>
              </div>
            }
          >
            <AssistantForm
              data={{
                form,
                handleFormChange,
                handleSwitchChange,
                isAdmin,
                handleUploadFileAndCreateAssistant,
                fileList,
                setFileList,
                setCountTotalFile,
                countTotalFile,
                isUploading,
                handleRemoveFile,
                handleAddFile,
                assistantData,
                setAssistantData,
                editMode,
                image,
                setImage,
                setDeleteFileIds,
                formattedRAGdData,
                formattedPublicFilesData,
                knowledgeSource,
                setKnowledgeSource,
                activeKeyOfKnowledgeBase,
                setActiveKeyOfKnowledgeBase,
                setTotalFileList,
                connectApps,
                setConnectApps,
                isWorkBoardConnected,
                setIsWorkBoardConnected,
                isGoogleDriveConnected,
                setIsGoogleDriveConnected,
                isImportWebPagesConnected,
                setIsImportWebPagesConnected,
                isActiveCollabConnected,
                setIsActiveCollabConnected,
                enableSync,
                setEnableSync,
                handleSwitchChangeOfPlugin,
                selectedPlugins,
                setSelectedPlugins,
                isHubspotConnected,
                setIsHubspotConnected,
                handleSelectChannel,
                setSelectedChannelId,
                selectedChannelId,
                isModalOpen,
                setIsModalOpen,
                channels,
                setChannels,
                loading,
                setLoading,
                selectedChannelName,
                setSelectedChannelName,
                isSlackConnected,
                setIsSlackConnected,
                hubspotPipelines: assistantData?.hubspotPipelines,
                imageType,
                setImageType,
                dalleImageDescription,
                setDalleImageDescription,  
                setFunctionCount,
                deletedFileList, 
                setDeletedFileList,        
              }}
            />
          </TabPane>}


          {userRole == 'superadmin' && (editMode ? null : (
            <TabPane
              key={"optimized-data"}
              tab={
                <div
                  style={{
                    display: "flex",
                    gap: ".6rem",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FaHashtag />
                  <span>New Agent by ID</span>
                </div>
              }
            >
              <Form
                form={form}
                layout="vertical"
                style={{
                  width: "100%",
                }}
              >
                <Form.Item style={{ width: '100%' }} label="Agent ID" name="assistantId">
                  <Input placeholder="Enter  Agent ID" />
                </Form.Item>
                {isAdmin && (
                  <Form.Item
                    label="Select type"
                    name="category"
                    rules={[
                      {
                        required: true,
                        message: "Please Select the type of Agent",
                      },
                    ]}
                  >
                    <Radio.Group>
                      <Radio value="ORGANIZATIONAL">Organizational</Radio>
                      <Radio value="PERSONAL">Personal</Radio>
                    </Radio.Group>
                  </Form.Item>
                )}
                <Form.Item label=" " colon={false}>
                  <Button
                    style={{ display: 'block', marginLeft: 'auto' }}
                    type="primary"
                    onClick={handleUploadFileAndCreateAssistant}
                  >
                    Create Agent
                  </Button>
                </Form.Item>
              </Form>
            </TabPane>
          ))}
        </Tabs>
      </Modal>
    </>
  );
};

export default CreateAssistantModal;
